import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Reusable Input component
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.error - Error message
 */
export const Input = React.forwardRef(({ className, error, icon: Icon, ...props }, ref) => {
  return (
    <div className="relative">
      {Icon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
          <Icon size={20} />
        </div>
      )}
      <input
        ref={ref}
        className={cn(
          'w-full py-3 border rounded-lg transition-all',
          Icon ? 'pl-10 pr-4' : 'px-4',
          'focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',
          'disabled:bg-gray-100 disabled:cursor-not-allowed',
          error ? 'border-red-500' : 'border-gray-300',
          className
        )}
        {...props}
      />
    </div>
  );
});

Input.displayName = 'Input';
